import { Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { JobSkillsSummaryDetailsBasicInfo } from '@core/positions-and-skills-types';
import { Theme } from '@core/theme-util';

@Component({
  selector: 'rt-skills-chart-tooltip',
  templateUrl: './skills-chart-tooltip.component.html',
  styleUrl: './skills-chart-tooltip.component.less',
  imports: [TranslatePipe],
})
export class SkillsChartTooltipComponent {
  protected readonly rows = computed(() => {
    const summary = this.summary();
    const theme = this.theme();

    return [
      {
        labelKey: 'app.interview.summary.skills_summary.status.above_required_level',
        count: summary.aboveRequiredLevelSkills.length,
        color: theme.colorBgSuccessDefault,
      },
      {
        labelKey: 'app.interview.summary.skills_summary.status.at_required_level_full',
        count: summary.atRequiredLevelSkills.length,
        color: theme.colorBgSuccessDisabled,
      },
      {
        labelKey: 'app.interview.summary.skills_summary.status.below_required_level',
        count: summary.belowRequiredLevelSkills.length,
        color: theme.colorBgCriticalDisabled,
      },
    ].filter(row => row.count > 0);
  });

  public summary = input.required<JobSkillsSummaryDetailsBasicInfo>();
  public theme = input.required<Theme>();
}
